import React from 'react'
import PropTypes from 'prop-types'
import LinkButton from './LinkButton'

function PinkLinkButton ({ className = '', ...props }) {
  return (
    <LinkButton classList={`vsd-button__filled vsd-button__extra-small inline-flex justify-center ${className}`} {...props} />
  )
}

PinkLinkButton.propTypes = {
  href: PropTypes.string,
  content: PropTypes.array,
  dataSource: PropTypes.string,
  trackedEvent: PropTypes.string,
  className: PropTypes.string
}

export default PinkLinkButton
